import {on} from '@acng/frontend-bounty/dom/event.js';
import {ENUM, guard} from '@acng/frontend-rubicon';
import {AttributeLink} from '@acng/frontend-stargazer';
import {getState} from 'acng/voyager/context/state';
import {trackOncePerMinute} from '../service/activity';

/**
 * @group DOM Attribute
 */
const name = 'track-user-state';

/**
 * @type {['enter', 'nochange', 'active']}
 */
const possibleEvents = ['enter', 'nochange', 'active'];

const POSSIBLE_VALUES = /* @__PURE__ */ ENUM(possibleEvents);

AttributeLink(name, (element, value) => () => {
  ASSERT: guard(value, POSSIBLE_VALUES, `[${name}] value`);
  on(getState(element), value, trackOncePerMinute);
});

export {name as TRACK_USER_STATE};
